<div class="row">
    <div class="col-12">
        <a class="d-flex align-items-center ms-n2 cursor-pointer" routerLink="{{ link.path }}" [queryParams]="link.queryParams" data-uit="navigation-link">
            <ca-icon class="me-1 arrow-left cursor-pointer" name="arrow-left" size="s"></ca-icon>
            <span>{{ link.nameTranslationKey | translate }}</span>
        </a>
    </div>
</div>
